import { isDevMode } from '@angular/core';

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions, @typescript-eslint/no-explicit-any
export function throwNever(input: any): void {
  if (isDevMode()) {
    throw new Error(`Input is not mapped in switch: ${JSON.stringify(input)}`);
  }
}
